import React, { useState } from 'react';
import { Colors } from '_styles';

const LoginButton = (props) => {

    const [toggle, setToggle] = useState(false);        // toggle on hover

    if (props.text == 'Register') {
        return (
            <>
                <div onClick={() => { props.onClick() }} style={{ opacity: toggle ? 0.6 : 1.0, width: 90, height: 40, borderRadius: 10, boxShadow: "0px 4px 8px 0px #9E9E9E", textAlign: 'center', backgroundColor: Colors.PRM_LIGHT_BLUE, cursor: 'pointer' }} onMouseEnter={() => { setToggle(true) }} onMouseLeave={() => { setToggle(false) }}>
                    <p style={{ fontSize: 18, fontWeight: '200', marginTop: 5, color: 'white' }}>{props.text}</p>
                </div>
            </>
        );
    }
    else {
        return (
            <>
                <div onClick={() => { props.onClick() }} style={{ opacity: toggle ? 0.6 : 1.0, width: 120, height: 50, borderRadius: 10, boxShadow: "0px 4px 8px 0px #9E9E9E", textAlign: 'center', backgroundColor: Colors.PRM_LIGHT_BLUE, marginLeft: 5, cursor: 'pointer', padding: 5 }} onMouseEnter={() => { setToggle(true) }} onMouseLeave={() => { setToggle(false) }}>
                    <p style={{ fontSize: 18, fontWeight: '200', marginTop: 5, color: 'white' }}>{props.text}</p>
                </div>
            </>
        );
    }


}


export default LoginButton;